var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("app-side-menu", [
    _c(
      "aside",
      { staticClass: "menu", attrs: { slot: "side-menu" }, slot: "side-menu" },
      [
        _c("p", { staticClass: "menu-label" }, [
          _c("span", { staticClass: "title is-6" }, [
            _vm._v(" Rego: " + _vm._s(_vm.entityName) + " "),
          ]),
        ]),
        _vm.innerValue
          ? _c("ul", { staticClass: "menu-list" }, [
              _c("li", [
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Theme")]),
                  _c("div", { staticClass: "control" }, [
                    _c("div", { staticClass: "select is-fullwidth" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.innerValue.theme,
                              expression: "innerValue.theme",
                            },
                          ],
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.innerValue,
                                "theme",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        _vm._l(_vm.themes, function (theme, index) {
                          return _c(
                            "option",
                            { key: index, domProps: { value: theme } },
                            [_vm._v(_vm._s(theme))]
                          )
                        }),
                        0
                      ),
                    ]),
                  ]),
                ]),
                _c("span", { staticClass: "buttons has-addons" }, [
                  _c(
                    "span",
                    {
                      staticClass: "button",
                      class: { "is-success": _vm.innerValue.lineWrapping },
                      on: { click: _vm.toggleLineWrapping },
                    },
                    [
                      _c("span", { staticClass: "icon" }, [
                        _c("i", { staticClass: "mdi mdi-wrap" }),
                      ]),
                      _c("span", [_vm._v("Wrap")]),
                    ]
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }